import React, { Component } from 'react';

class MapControls extends Component {
    constructor(props){
        super(props);
        this.clickHandler = this.clickHandler.bind(this);
    }

    clickHandler (e){
        let id = e.target.id, 
            map = this.props.map;

        if(id === 'satelite'){
            map.setLayoutProperty('uaeu-raster', 'visibility', 'visible');
            this.props.setMapStyle('satelite');
        } else if(id === 'vmap'){
            map.setLayoutProperty('uaeu-raster', 'visibility', 'none');            
            this.props.setMapStyle('basic');
        }else{
            map.flyTo({
                center: [55.67900, 24.19760],
                speed: 0.5,
                zoom: 15
            });
        }

    }
    
    showDirection(e){
        this.props.setDirection(this.props.mapDirection ? false : true);
        this.props.menuToggle(!this.props.mapDirection ? false : true);       

        if(this.props.mapDirection === true && this.props.map.getLayer('dir')){
            this.props.map.setLayoutProperty('dir', 'visibility' , 'none');
            this.props.map.setLayoutProperty('uaeu-start', 'visibility' , 'none');
            this.props.map.setLayoutProperty('uaeu-end', 'visibility' , 'none');


        }
    }
    render(){
        return(
            <ul className="no-list" id="map-styles">
                <li id="home" onClick={this.clickHandler}></li>
                <li id="vmap" className={this.props.mapStyle === 'basic' ? 'active' : ''} onClick={this.clickHandler}>Map</li>
                <li id="satelite" className={this.props.mapStyle === 'satelite' ? 'active' : ''} onClick={this.clickHandler}>Satelite</li>
                <li className={this.props.mapDirection ? 'active' : ''} onClick={this.showDirection.bind(this)}>Directions</li>
            </ul>
        )
    }
}

export default MapControls;


// WEBPACK FOOTER //
// ./src/components/MapControls.js